var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6923 16.0001C11.05 16.0001 10.5048 15.7761 10.0567 15.328C9.60866 14.8799 9.38463 14.3347 9.38463 13.6924C9.38463 13.0501 9.60866 12.5049 10.0567 12.0569C10.5048 11.6088 11.05 11.3848 11.6923 11.3848C12.3346 11.3848 12.8798 11.6088 13.3279 12.0569C13.7759 12.5049 14 13.0501 14 13.6924C14 14.3347 13.7759 14.8799 13.3279 15.328C12.8798 15.7761 12.3346 16.0001 11.6923 16.0001ZM2.3077 19.5001C1.80257 19.5001 1.375 19.3251 1.025 18.9751C0.675 18.6251 0.5 18.1975 0.5 17.6924V4.30784C0.5 3.80271 0.675 3.37514 1.025 3.02514C1.375 2.67514 1.80257 2.50014 2.3077 2.50014H3.69233V0.384766H5.23075V2.50014H12.8077V0.384766H14.3076V2.50014H15.6923C16.1974 2.50014 16.625 2.67514 16.975 3.02514C17.325 3.37514 17.5 3.80271 17.5 4.30784V17.6924C17.5 18.1975 17.325 18.6251 16.975 18.9751C16.625 19.3251 16.1974 19.5001 15.6923 19.5001H2.3077ZM2.3077 18.0001H15.6923C15.7692 18.0001 15.8397 17.9681 15.9038 17.904C15.9679 17.8398 16 17.7693 16 17.6924V8.30784H1.99997V17.6924C1.99997 17.7693 2.03202 17.8398 2.09612 17.904C2.16024 17.9681 2.23077 18.0001 2.3077 18.0001Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalalender);
export default __webpack_public_path__ + "static/media/calalender.29b0a62c04256eea2e5ac23b88794ff1.svg";
export { ForwardRef as ReactComponent };